<template>
  <div
    class="co-bot-highlight"
    :class="{ 'co-bot-highlight--muted': !highlighted }"
  >
    <div
      class="co-bot-highlight__orb"
      aria-hidden="true"
    >
      <feather-icon
        icon="CpuIcon"
        size="36"
      />
    </div>
    <div class="co-bot-highlight__body">
      <p class="co-bot-highlight__eyebrow">
        Desempenho do bot
      </p>
      <h3 class="co-bot-highlight__headline">
        {{ headline }}
      </h3>
      <ul class="co-bot-highlight__list">
        <li
          v-for="(line, i) in bullets"
          :key="i"
        >
          <feather-icon
            icon="CheckCircleIcon"
            size="16"
            class="co-bot-highlight__icon"
          />
          <span>{{ line }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CentralBotHighlight',
  props: {
    headline: {
      type: String,
      default: '',
    },
    bullets: {
      type: Array,
      default: () => [],
    },
    highlighted: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
.co-bot-highlight {
  position: relative;
  border-radius: 20px;
  padding: 1.5rem 1.5rem 1.5rem 1.25rem;
  min-height: 100%;
  background: linear-gradient(135deg, rgba(106, 27, 154, 0.09) 0%, rgba(255, 111, 97, 0.12) 100%);
  border: 1px solid rgba(106, 27, 154, 0.15);
  box-shadow: 0 12px 40px rgba(106, 27, 154, 0.08);
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  overflow: hidden;
}

.co-bot-highlight--muted {
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.02) 0%, rgba(106, 27, 154, 0.04) 100%);
  border-color: rgba(0, 0, 0, 0.06);
  box-shadow: none;
}

.co-bot-highlight__orb {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: linear-gradient(145deg, #7b1fa2, #ff6f61);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(123, 31, 162, 0.35);
}

.co-bot-highlight--muted .co-bot-highlight__orb {
  background: linear-gradient(145deg, #9e9e9e, #bdbdbd);
  box-shadow: none;
}

.co-bot-highlight__body {
  flex: 1;
  min-width: 0;
}

.co-bot-highlight__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #7b1fa2;
  font-weight: 700;
}

.co-bot-highlight--muted .co-bot-highlight__eyebrow {
  color: #757575;
}

.co-bot-highlight__headline {
  margin: 0 0 0.85rem;
  font-size: 1.25rem;
  font-weight: 800;
  color: #4a148c;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.co-bot-highlight--muted .co-bot-highlight__headline {
  color: #424242;
}

.co-bot-highlight__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.co-bot-highlight__list li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.9rem;
  line-height: 1.45;
  color: #424242;
  margin-bottom: 0.5rem;
}

.co-bot-highlight__list li:last-child {
  margin-bottom: 0;
}

.co-bot-highlight__icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: #26a69a;
}

.co-bot-highlight--muted .co-bot-highlight__icon {
  color: #9e9e9e;
}
</style>
